import React from 'react';
import { Panel, Card } from "rbx";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";

const MenuItems = (props) => {
  const { setItemSelected, links, linksExtras } = props;

  return (
    <>
      <Panel className='has-background-white'>
        <Card.Header>
          <Card.Header.Title>O que você quer fazer ?</Card.Header.Title>
        </Card.Header>
        {
          links.map((link) => (
            <Panel.Block>
              <Panel.Icon>
                <FontAwesomeIcon icon={faEllipsisV} />
                <FontAwesomeIcon icon={faEllipsisV} />
              </Panel.Icon>
              <Link onClick={()=>setItemSelected(link.item)}>{link.description}</Link>
            </Panel.Block>
          ))
        }
      </Panel>

      <Panel className='has-background-white'>
        <Card.Header>
          <Card.Header.Title>Extras</Card.Header.Title>
        </Card.Header>
        {
          linksExtras.map((linkExtra) => (
            <Panel.Block>
              <Panel.Icon>
                <FontAwesomeIcon icon={faEllipsisV} />
                <FontAwesomeIcon icon={faEllipsisV} />
              </Panel.Icon>
              <Link to={linkExtra.url}>{linkExtra.description}</Link>
            </Panel.Block>
          ))
        }
      </Panel>
    </>
  )
}

export default MenuItems;

